export const enum FeedbackTypes {
    customerRefused,
    trailerDamaged,
    unableToFindTrailer,
    trailerIsLoaded,
    anotherTruckIsAttached,
}
